import dashboard from '../components/dashboard'
import accounts from '../components/accounts'
import callrecords from '../components/callrecords'
import extensions from '../components/extensions'
import reports from '../components/reports'

export default [
  { path: '/', component: dashboard },
  { path: '/accounts', component: accounts },
  { path: '/callrecords', component: callrecords },
  { path: '/extensions', component: extensions },
  { path: '/reports', component: reports }
]
